import { useEffect, useRef } from 'react'

import './SentenceVictimScreen.css'
import { DefaultScreenProps } from '../defaultScreenProps'
import { Victim } from '../../types/victimTypes'
import { useSkipNarration } from '../../hooks/useSkipNarration'
import { SkipHint } from '../../components/SkipHint/SkipHint'

type SentenceVictimScreenProps = DefaultScreenProps & {
  saySentenceVictim: () => void
  getDoomedVictim: () => Victim
  skipNarration: () => void
}

export const SentenceVictimScreen = ({
  saySentenceVictim,
  getDoomedVictim,
  skipNarration,
}: SentenceVictimScreenProps) => {
  const audioPlayedRef = useRef(false)

  useEffect(() => {
    if (!audioPlayedRef.current) {
      saySentenceVictim()
      audioPlayedRef.current = true
    }
  }, [saySentenceVictim])

  useSkipNarration(skipNarration)

  const victim = getDoomedVictim()

  return (
    <div className="sentenceVictimScreenContainer">
      {/* Same painting, blurred and darkened, fills the 16:9 frame so the
          1:1 art is not flanked by two black pillars on a TV. */}
      <img
        className="sentencedVictimBackdrop"
        src={victim.image}
        alt=""
        aria-hidden="true"
      />
      <img
        className="sentencedVictimImage"
        src={victim.image}
        alt={`${victim.name}, sentenced to death by trolley`}
      />
      <SkipHint />
    </div>
  )
}
